<template>
      <div class="ingredient_container container" v-if="results.length>0">

        <div class="row ingredient_header">
          <div class="col-sm-6 ">

            <div v-if="results[0].image">
              <div class="central_img" v-if="!img_isEditing"  :style="{ backgroundImage: 'url(' + results[0].image + ')' }"> </div>
            </div>
            <div  v-else>
              <div class="central_img no_photo_txt style-italic t-details-color" v-if="!img_isEditing">
                  {{ $t('info.no_image') }}
              </div>
            </div>
            <div v-if="img_isEditing">
              <p class="subtext">{{ $t('subtetexts.media') }}</p>
              <input type="file" v-on:change="handleFileChange()" ref="image" name="image" id="image" class="text_input img_input">
            </div>
            <div class="img_btn">
                <EditButton
                  v-if="user.data && (user.data.profile.admin || user.data.profile.editor)"
                    :isEditing="img_isEditing"
                    :I_am_the_author="I_am_the_author"
                    align="right"
                    text="εικόνας"
                    border="no-border"
                    v-on:edit-pressed="img_isEditing = true"
                    v-on:save-pressed="updateIngredientData().then(data=>{img_isEditing = false})"
                  />
            </div>

          </div>
          <div class="col-sm-6 ">
            <div class="first_info">
              <h1>{{results[0].name}}</h1>

              <h6 class="t-details-color font-size-xs style-italic">
                <svg class="ingr_details_icon"><use href="@/assets/icon_sprite.svg#portions"/></svg> 
                Κατηγορία
              </h6>  
              <p>
                {{ results[0].category || $t('ingredient.category_unavailable') }}
              </p>
              <h6 class="t-details-color font-size-xs style-italic">
                <svg class="ingr_details_icon"><use href="@/assets/icon_sprite.svg#spoon"/></svg>  
                Μετρήσεις
              </h6>
              <p>              
                <span class="unit" v-for="ingredient_unit in results[0].units" :key="ingredient_unit" >
                  {{ingredient_unit}}
                </span>
              </p>
             
              <table v-if="results[0].grammar || grammar_isEditing" class="grammar">
                <tr>
                  <th class="t-details-color font-size-xs style-italic">Ενικός</th>
                  <th class="t-details-color font-size-xs style-italic">Πληθυντικός</th>
                </tr>
                <tr>
                  <td>
                    <p v-if="!grammar_isEditing">{{results[0].grammar.singular}}</p>
                    <input v-if="grammar_isEditing" v-model="results[0].grammar.singular" type="text" name="grammar_singular" class="text_input full_width_input" >
                  </td>
                  <td>
                    <p v-if="!grammar_isEditing">{{results[0].grammar.plural}}</p>
                    <input v-if="grammar_isEditing" v-model="results[0].grammar.plural" type="text" name="grammar_plural" class="text_input full_width_input" >
                  </td>
                </tr>
              </table>

               <div class="img_btn">
                <EditButton
                  v-if="user.data && (user.data.profile.admin || user.data.profile.editor)"
                    :isEditing="grammar_isEditing"
                    :I_am_the_author="I_am_the_author"
                    align="left"
                    text="γραμματικής"
                    border="no-border"
                    v-on:edit-pressed="startGrammarEdit()"
                    v-on:save-pressed="updateIngredientData().then(data=>{grammar_isEditing = false})"
                  />
                </div>

            </div>
          </div>
          <div class="col-md-12">
            <p v-if="results[0].description && !description_isEditing" v-html="this.md(results[0].description)">
            </p>
            <div v-if="description_isEditing">
              <p class="subtext"> {{ $t('subtexts.markdown') }}</p>
              <!-- <input v-model="results[0].description" type="text" name="description" class="text_input name_input" placeholder="Λίγα λόγια για το υλικό..." > -->
              <textarea rows="5" v-model="results[0].description" name="description" id="description" class="text_input full_width_input" placeholder="Λίγα λόγια για το υλικό..."/>

            </div>

            <div class="img_btn">
                <EditButton
                  v-if="user.data && (user.data.profile.admin || user.data.profile.editor)"
                    :isEditing="description_isEditing"
                    :I_am_the_author="I_am_the_author"
                    align="right"
                    text="περιγραφής"
                    border="no-border"
                    v-on:edit-pressed="description_isEditing = true"
                    v-on:save-pressed="updateIngredientData().then(data=>{description_isEditing = false})"
                  />
            </div>
          </div>
        </div>
        <div class="row nutrition_section">
          <div class="col-md-12">
            <!-- NutritionFacts renders its own "nutrition.title" heading, so this one
                 only covers the states where that component isn't shown. -->
            <h3 v-if="nutrition_isEditing || !(results[0].nutrition && results[0].nutrition.per_100)">{{ $t('nutrition.title') }}</h3>
            <div v-if="!nutrition_isEditing">
              <NutritionFacts
                v-if="results[0].nutrition && results[0].nutrition.per_100"
                :totals="results[0].nutrition.per_100"
                :basis-label="$t('nutrition.per_100_basis') + ' ' + (results[0].nutrition.basis || 'g')"
              />
              <p v-else class="t-details-color style-italic">{{ $t('nutrition.unavailable') }}</p>
              <p class="usda_linked_info" v-if="I_am_the_author && usdaLinkedFdcId">
                {{ $t('nutrition.usda_linked') }}
                <a :href="'https://fdc.nal.usda.gov/food-details/' + usdaLinkedFdcId + '/nutrients'" target="_blank" rel="noopener">fdc_id: {{ usdaLinkedFdcId }}</a>
              </p>
            </div>
            <div v-if="nutrition_isEditing" class="nutrition_form">
              <div class="basis_row">
                <label>{{ $t('nutrition.basis') }}:</label>
                <select v-model="results[0].nutrition.basis" class="text_input">
                  <option value="g">g</option>
                  <option value="ml">ml</option>
                </select>
              </div>
              <div class="nutrition_input_row" v-for="field in ['calories','protein','carbohydrates','fats']" :key="field">
                <label>{{ $t('nutrition.' + field) }}</label>
                <input type="number" min="0" step="0.1" v-model.number="results[0].nutrition.per_100[field]" class="text_input">
              </div>
              <h4>{{ $t('nutrition.unit_conversions') }}</h4>
              <div class="conversion_row" v-for="(row, index) in nutrition_conversions" :key="index">
                <input type="text" v-model="row.unit" :placeholder="$t('nutrition.unit')" class="text_input">
                <input type="number" min="0" step="0.1" v-model.number="row.grams" :placeholder="isBasisUnit(row.unit) ? $t('nutrition.auto_1_to_1') : $t('nutrition.grams_per_unit')" class="text_input">
                <button type="button" @click="removeConversionRow(index)" class="remove_btn">×</button>
              </div>
              <button type="button" @click="addConversionRow" class="add_btn primary_btn">+ {{ $t('nutrition.add_conversion') }}</button>
            </div>
            <div class="img_btn">
              <EditButton
                v-if="user.data && (user.data.profile.admin || user.data.profile.editor)"
                  :isEditing="nutrition_isEditing"
                  :I_am_the_author="I_am_the_author"
                  align="left"
                  text="διατροφικών στοιχείων"
                  border="no-border"
                  v-on:edit-pressed="startNutritionEdit()"
                  v-on:save-pressed="saveNutritionEdit().then(data=>{nutrition_isEditing = false})"
                />
              <button
                type="button"
                class="primary_btn usda_link_btn"
                v-if="!nutrition_isEditing && I_am_the_author"
                @click="showUsdaModal = true"
              >{{ usdaLinkedFdcId ? $t('nutrition.usda_relink_button') : $t('nutrition.usda_link_button') }}</button>
            </div>
            <p class="usda_link_note" v-if="usdaLinkNote">{{ usdaLinkNote }}</p>
          </div>
        </div>

        <UsdaLinkModal
          v-if="showUsdaModal"
          :name="results[0].name"
          :english-name-used="results[0].english_name"
          v-on:decline-action="showUsdaModal = false"
          v-on:linked="onUsdaLinked"
        />

        <div class="recipes_section">
          <h3>Συνταγές με {{results[0].name}} </h3>
          <div class="recipes_cards row no-gutters">
            <div class=" col-md-4" v-for="recipe in recipies_with" :key="recipe.id" >
                <RecipeCard v-bind:result="recipe"/>
            </div>
          </div>
        </div>

        <IngredientQuestion :ingredient_id="results[0].name" v-if="user.data" />
        <!-- <IngredientQuestion :ingredients="ingr_List" v-if="user.data" /> -->

      </div>
      <div v-else> 
          <h1> Το υλικό δεν βρέθηκε</h1>
          <button @click="$router.go(-1)" class="primary_btn">> Πίσω</button>

      </div>
</template>

<script>
import RecipeCard from './extras/Recipe_card.vue';
import EditButton from './extras/Edit_button.vue';
import IngredientQuestion from './extras/Ingredient_question.vue';
import NutritionFacts from './extras/Nutrition_facts.vue';
import UsdaLinkModal from './extras/Usda_link_modal.vue';

import { mapGetters } from "vuex";

export default {
    name: 'IngredientInternal',
    components: {
      RecipeCard,
      EditButton,
      IngredientQuestion,
      NutritionFacts,
      UsdaLinkModal

    },
    data(){
        return {
            results:[],

            recipies_with:[],
            error:false,
            image:"",

            img_isEditing:false,
            description_isEditing:false,
            grammar_isEditing:false,
            nutrition_isEditing:false,
            nutrition_conversions:[],
            showUsdaModal:false,
            usdaLinkNote:null,

            I_am_the_author:false,

        }
    },
    computed: {
    // map `this.user` to `this.$store.getters.user`
      ...mapGetters({
        user: "user"
      }),
      ingr_List() {
        return [this.results[0]];
      },
      // nutrition.source (not the top-level global_id) is the reliable signal
      // for "is this ingredient currently linked to a USDA food" — it's set by
      // every path that produces a database-quality match (pre-seed load,
      // reactive auto-match, AND manual admin linking), whereas global_id
      // historically was only set by the pre-seed pipeline.
      usdaLinkedFdcId() {
        let source = this.results[0] && this.results[0].nutrition && this.results[0].nutrition.source;
        if (!source || source.indexOf('usda:') !== 0) { return null; }
        return source.slice('usda:'.length);
      }
    },
    watch: {
      '$route.params.name': function () {
        this.getingredient();
      },
      "$store.getters.user.data": function () {
          if(this.user.data && this.user.data.profile && (this.user.data.profile.admin || this.user.data.profile.editor)){
            this.I_am_the_author = true;
          }
        }
    },

    mounted(){
      this.getingredient();
      this.getRecipesWithIngredient();
      if(this.user.data && this.user.data.profile && (this.user.data.profile.admin || this.user.data.profile.editor)){
        this.I_am_the_author = true;
      }
    },
    methods:{
      getRecipesWithIngredient: function(){
        fetch(process.env.VUE_APP_API+`/search/ingredients?ingredients=`+this.$route.params.name)
                .then(res => res.json())
                .then(res => {
                    this.searching = false;
                    if(res.error){
                        this.error = res.error;
                    }else{
                        if(res.length < 1){
                            this.error = "No recipes";
                        }else{
                            this.error = false;
                            this.recipies_with = res;
                        }
                    } 
                });
      },
      getingredient: function() {
        this.results = [];
        this.usdaLinkNote = null;
        fetch(process.env.VUE_APP_API+`/ingredients/getByName/`+this.$route.params.name)
          .then(res => res.json())
          .then(res => {
            if(res.error){
              this.error = res.error;
            }else{
              if(res.length < 1){
                this.error = "No results";
              }else{
                this.results = res;
            }
            }
          });
      },
      handleFileChange(){
        this.image = this.$refs.image.files[0];
      },
      onUsdaLinked({ nutrition, new_units }){
        // Merge the response directly instead of re-fetching: getByName reads
        // an eventually-consistent onSnapshot cache that can still be stale
        // immediately after this write commits (the response we already have
        // is the authoritative fresh result, not a second racy read of it).
        this.showUsdaModal = false;
        this.$set(this.results[0], 'nutrition', nutrition);
        if (new_units && new_units.length > 0) {
          let units = Array.isArray(this.results[0].units) ? [...this.results[0].units] : [];
          for (let unit of new_units) {
            if (units.indexOf(unit) === -1) { units.push(unit); }
          }
          this.$set(this.results[0], 'units', units);
          this.usdaLinkNote = this.$t('nutrition.usda_new_units') + ' ' + new_units.join(', ');
        } else {
          this.usdaLinkNote = this.$t('nutrition.usda_link_success');
        }
      },
      // Mirrors backend/services/mealplan_aggregate.js normalizeUnit exactly — the
      // aggregator looks up unit_conversions by this same normalized key, so a typed
      // unit that doesn't match it byte-for-byte would silently never resolve.
      normalizeUnit(raw){
        return String(raw == null ? "" : raw).trim().toLowerCase().replace(/\.+$/, "").replace(/\s+/g, " ");
      },
      // Mirrors backend/services/nutrition_aggregate.js BASIS_UNIT_ALIASES — these
      // units convert to the ingredient's basis (g or ml) automatically, so no editor
      // entered conversion is needed (or used) for them.
      isBasisUnit(unit){
        let normalized = this.normalizeUnit(unit);
        let basis = this.results[0].nutrition && this.results[0].nutrition.basis;
        let aliases = { g: ["γρ", "gr", "g"], ml: ["μλ", "ml"] };
        return !!basis && aliases[basis].indexOf(normalized) > -1;
      },
      startNutritionEdit(){
        if(!this.results[0].nutrition){
          this.$set(this.results[0], 'nutrition', { basis: 'g', per_100: { calories: 0, protein: 0, carbohydrates: 0, fats: 0 }, unit_conversions: {} });
        }
        if(!this.results[0].nutrition.per_100){
          this.$set(this.results[0].nutrition, 'per_100', { calories: 0, protein: 0, carbohydrates: 0, fats: 0 });
        }
        let conversions = this.results[0].nutrition.unit_conversions || {};
        // Pre-fill a row per unit this ingredient is actually used with in recipes
        // (results[0].units), instead of leaving the editor to hand-type unit strings
        // that risk not matching what the aggregator normalizes to. Legacy units that
        // are no longer in results[0].units but still have a saved conversion stay too.
        let knownUnits = (this.results[0].units || []).map(this.normalizeUnit);
        let allUnits = Array.from(new Set([...knownUnits, ...Object.keys(conversions)]));
        this.nutrition_conversions = allUnits.map((unit)=>{
          return { unit: unit, grams: conversions[unit] != null ? conversions[unit] : null };
        });
        this.nutrition_isEditing = true;
      },
      addConversionRow(){
        this.nutrition_conversions.push({ unit: '', grams: null });
      },
      removeConversionRow(index){
        this.nutrition_conversions.splice(index, 1);
      },
      saveNutritionEdit(){
        let conversions = {};
        for(let row of this.nutrition_conversions){
          let unit = this.normalizeUnit(row.unit);
          if(unit && row.grams){
            conversions[unit] = row.grams;
          }
        }
        this.results[0].nutrition.unit_conversions = conversions;
        return this.updateIngredientData();
      },
      startGrammarEdit() {
        if(!this.results[0].grammar){
          this.$set(this.results[0], 'grammar', {singular:'', plural:''});
        }
        this.grammar_isEditing = true;
      },
      updateIngredientData() {
        return new Promise((resolve,reject)=>{
          var ingredient_form = new FormData();
          
          ingredient_form.append('image',this.image);
          ingredient_form.append('ingredient', JSON.stringify(this.results[0]));
          fetch(process.env.VUE_APP_API+`/ingredients/update/`+this.results[0].name,{
              method: "post",
              headers: {
                  "TOKEN":JSON.stringify(this.user.data.token),
              },
              body: ingredient_form
          }).then(res => res.json())
            .then(res => {
                //TODO: Error Validation
                if(res.error){
                    this.errors = res.error
                }
                else {
                  this.$set(this.results, 0, res.ingredient);
                  this.image="";
                }
                resolve();
            });
        });
      }
    }
    
}
</script>

<style scoped lang="scss">

.ingredient_container{
  margin:auto;
  text-align: left;
  max-width: 840px;
}
.ingredient_header{
  padding-bottom: 2rem;
  border-bottom: var(--line-dashed);
  margin-bottom: 2rem;
}
.central_img{
  min-height: 340px;
  border-radius: 0 0 10px 10px;
  box-shadow: -17px -7px 0px -7px var(--color-secondary);
  margin-bottom: 2rem;
}
.dark .central_img {
  background-color: var(--color-text-primary);
}
.first_info {
  margin: 0.2rem 0.8rem;
  /* text-align: left; */
}
.first_info h1 {
  margin-top:0.6rem;
}
/* .first_info p {
  font-size: 0.8rem;
  color:var(--color-grey-2);
} */
// .first_info p svg {
//   width: 1rem;
//   height: 1rem;
//   fill: var(--color-grey-2);
// }
.recipes_section {
  margin-bottom: 2rem;
}

.unit {
  padding: 0 1rem;
  border-right:1px solid var(--color-grey-3);
  &:last-child {
    border:none;
  }
}

.grammar {
  width: 100%;
}
.grammar th, .grammar td {
  padding-right: 1rem;
}

.nutrition_section {
  margin-bottom: 2rem;
}
.usda_linked_info {
  font-size: 0.8rem;
  color: var(--color-grey-2);
  margin-top: 0.4rem;
}
.usda_linked_info a {
  color: var(--color-secondary);
}
.usda_link_note {
  font-size: 0.85rem;
  color: var(--color-secondary);
  margin-top: 0.5rem;
}
.nutrition_form .basis_row,
.nutrition_form .nutrition_input_row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.4rem;
}
.nutrition_form .nutrition_input_row label {
  min-width: 140px;
}
.nutrition_form .conversion_row {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.4rem;
}
.nutrition_form .remove_btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-grey-2);
  font-size: 1.2rem;
}

  @media (max-width: 576.98px) {
    .no_photo_txt {
      display: none;
    }
  }
</style>